import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import windowScrew from '../image/windowscrew.jpg';
import windowMagnetic from '../image/windowmagnetic.jpg';
import Breadcrumbs from './Breadcrumbs';
import './theme.css';

function MosquitoNetWindows() {
    const [activeTab, setActiveTab] = useState('screw');

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const keyFeatures = {
        screw: [
            { icon: 'bi-check-circle-fill', desc: 'Lightweight yet strong aluminium frame.' },
            { icon: 'bi-check-circle-fill', desc: 'Secure locking mechanism for added safety.' },
            { icon: 'bi-check-circle-fill', desc: 'Affordable and practical design.' },
            { icon: 'bi-check-circle-fill', desc: 'Best Suitable for Homes, Small offices, Ventilation windows.' },
        ],
        magnetic: [
            { icon: 'bi-check-circle-fill', desc: 'Strong aluminium frame for heavy-duty usage.' },
            { icon: 'bi-check-circle-fill', desc: 'Magnetic strip closing system.' },
            { icon: 'bi-check-circle-fill', desc: 'Weather strip for dust control and silent closure.' },
            { icon: 'bi-check-circle-fill', desc: 'Best Suitable for Homes & Villas, Apartments, Commercial Offices, Hotels & Lodges, Balconies & High-ventilation areas.' },
        ],
    };

    const benefits = {
        screw: [
            { icon: 'bi-check-circle-fill', desc: 'Prevents mosquitoes and insects.' },
            { icon: 'bi-check-circle-fill', desc: 'Easy to operate for all age groups.' },
            { icon: 'bi-check-circle-fill', desc: 'Strong frame with long service life.' },
            { icon: 'bi-check-circle-fill', desc: 'Cost-effective without compromising quality.' },
            { icon: 'bi-check-circle-fill', desc: 'Rust-free construction.' },
        ],
        magnetic: [
            { icon: 'bi-check-circle-fill', desc: 'Premium magnetic sealing system.' },
            { icon: 'bi-check-circle-fill', desc: 'Blocks mosquitoes, dust, and insects.' },
            { icon: 'bi-check-circle-fill', desc: 'Strongest frame build in its category.' },
            { icon: 'bi-check-circle-fill', desc: 'Smooth, soft-closing performance.' },
            { icon: 'bi-check-circle-fill', desc: 'Perfect for high-usage windows & doors.' },
        ],
    };


    return (
        <div className="container-fluid p-0 ">
            <Header />
            <section className="theme-section">
                <Breadcrumbs/>
                <div className="container" data-aos="fade-up">
                    <div className="theme-section-title text-center">
                        <h2>Mosquito Net Window System</h2>
                        <p>
                            Upgrade your space with our Door-Type Aluminium Window System, engineered for strength, smooth operation, and lasting comfort.
                            Built with premium aluminium channels and high-quality fittings, this window not only enhances airflow but also protects your home from insects and dust.
                            The door-style opening makes it easy to operate and maintain, making it ideal for homes, commercial buildings, and industrial spaces.</p>
                    </div>

                    {/* === Tabs === */}
                    <div className="theme-tabs" data-aos="fade-up" data-aos-delay="100">
                        {['screw', 'magnetic'].map((tab) => (
                            <div
                                key={tab}
                                className={`theme-tab-link ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab === 'screw' ? 'Screw / Fixed Mosquito Net Window System ' : 'MagPro Net Door System'}
                            </div>
                        ))}
                    </div>

                    {/* === Tab Content === */}
                    <div className="theme-row" data-aos="fade-up">
                        {activeTab === 'screw'
                            ?
                            <div>
                                <p>Our Screw / Fixed Aluminium Mosquito Net Door System is designed to provide long-lasting protection from insects
                                    while allowing free airflow and clear visibility. Built using a strong aluminium frame with reinforced PVC components,
                                    this system functions like a mini door for your window opening smoothly and locking securely for daily use.</p>
                                <p>This model is ideal for homes and small commercial spaces that need a simple, durable, and cost-effective mesh door solution.</p>
                            </div>
                            :
                            <div>
                                <p> The MagnaSeal Pro Mesh Door is our premium mosquito-net door system engineered using high-grade aluminium channels for superior strength and durability. This advanced design features magnetic strips and weather stripping for a tight, noise-free, and dust-controlled seal.</p>
                                <p>This model ensures smooth operation, long-term performance, and a premium finish suitable for homes, villas, and commercial spaces. </p>
                            </div>
                        }
                    </div>

                    <div className="theme-row" data-aos="fade-up">
                        <div className="col-lg-6 theme-col">
                            <h6>Key Features</h6>
                            <ul className="theme-features">
                                {keyFeatures[activeTab].map((item, index) => (
                                    <li key={index}>
                                        <i className={`bi ${item.icon}`}></i>{item.desc}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="col-lg-6 theme-col theme-image-wrapper" data-aos="zoom-in">
                            <img
                                src={activeTab === 'screw' ? windowScrew : windowMagnetic}
                                alt="Mosquito Net Window"
                                className="theme-image"
                            />
                        </div>
                    </div>

                    <div className='theme-row' data-aos="fade-up">
                        <div className="theme-col">
                            <h6>Benefits</h6>
                            <ul className="theme-features">
                                {benefits[activeTab].map((item, index) => (
                                    <li key={index}>
                                        <i className={`bi ${item.icon}`}></i>{item.desc}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className='theme-row' data-aos="fade-up">
                        <div className="theme-col">
                            <h6>Materials Used</h6>
                            <p className='muted small'>Built with high-quality components to ensure durability, strength and low maintenance.</p>
                            {
                                activeTab === 'screw'
                                    ?
                                    <div className="fabric-list">
                                        <div className="chip">Aluminium Channel</div>
                                        <div className="chip">SS Net</div>
                                        <div className="chip">Heel</div>
                                        <div className="chip">Hinges</div>
                                        <div className="chip">Handle</div>
                                        <div className="chip">Lock</div>
                                    </div>
                                    :
                                    <div className="fabric-list">
                                        <div className="chip">Aluminium Channel</div>
                                        <div className="chip">SS Net</div>
                                        <div className="chip">Heel</div>
                                        <div className="chip">Hinges</div>
                                        <div className="chip">Handle</div>
                                        <div className="chip">Magnetic Strip</div>
                                        <div className="chip">Weather Strip</div>
                                    </div>
                            }
                        </div>
                    </div>

                    {/* === Feature Boxes === */}
                    <div className="row theme-feature-section">
                        <div className="theme-feature-box">
                            {activeTab === 'screw'
                                ? <p className="theme-feature-description">Simple, efficient, and affordable the perfect basic mosquito-net door system for everyday use.</p>
                                :
                                <p className="theme-feature-description">Premium strength, magnetic sealing, and flawless performance built for customers who want the best.</p>
                            }
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default MosquitoNetWindows;
